import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });




  const skills = [
    "Figma", "Gemini", "Cursor", "Pendo", "ChatGPT", 
    "Midjourney", "Linear", "Lovable", "V0"
  ];

  const siteTools = ["Gemini", "Cursor", "Midjourney", "ChatGPT"];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  const skillVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.4,
        ease: "easeOut"
      }
    }
  };

  return (
    <section id="about" className="py-24 bg-background">
      <div className="container-max section-padding">
        <motion.div
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={containerVariants}
        >
          <motion.div className="text-center mb-16" variants={itemVariants}>
            <h2 className="text-4xl md:text-5xl font-bold text-text-main mb-6">
              A Little More About Me
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <motion.div variants={itemVariants}>

              <div className="prose prose-lg max-w-none">
                <p className="text-secondary-accent leading-relaxed mb-6">
                  I'm passionate about building products that make a real difference in people's lives. 
                  With over a decade of experience in product management, I've had the privilege of working 
                  with incredible teams to bring innovative solutions to market.
                </p>
                
                <p className="text-secondary-accent leading-relaxed mb-6">
                  Outside of work, I'm passionate about hands-on projects, whether it's DIY home improvement, 
                  gardening, or cooking. I enjoy the process of building things from the ground up—a principle 
                  I apply to my work in product.
                </p>
                
                <p className="text-secondary-accent leading-relaxed">
                  I'm also a cyclist, parent, and always curious about the next frontier of technology. 
                  I believe in the power of combining analytical thinking with creative problem-solving 
                  to create products that users love.
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants}>
              <div className="bg-white rounded-3xl p-8 shadow-sm">
                <h3 className="text-2xl font-bold text-text-main mb-8">My Toolkit</h3>
                
                <motion.div 
                  className="grid grid-cols-3 gap-4"
                  variants={containerVariants}
                >
                  {skills.map((skill, index) => {
                    const isUsedForSite = siteTools.includes(skill);
                    return (
                      <motion.div
                        key={skill}
                        className="group relative"
                        variants={skillVariants}
                        whileHover={{ scale: 1.05 }}
                        transition={{ type: "spring", stiffness: 400, damping: 10 }}


                      >
                        <div className={`rounded-2xl p-4 text-center transition-all duration-200 cursor-pointer ${
                          isUsedForSite 
                            ? 'bg-primary-accent text-white hover:bg-primary-accent/80' 
                            : 'bg-subtle-accent hover:bg-subtle-accent/70'
                        }`}>
                          <div className="text-sm font-semibold">
                            {skill}
                          </div>
                        </div>

                      </motion.div>
                    );
                  })}
                </motion.div>

                <motion.div 
                  className="mt-8 text-center"
                  variants={itemVariants}
                >
                  <p className="text-sm text-primary-accent font-medium">
                    Used to create this site
                  </p>
                </motion.div>
              </div>
            </motion.div>
          </div>


        </motion.div>
      </div>
    </section>
  );
};

export default About; 